// Arrow Icon:
// Next Arrow (>) icon.

// Core
import React from 'react'

const Next = () => (
  <svg width="94.32" viewBox="0 0 94.32 76.15">
    <g>
      <path d="M94.32,38.07,56.4,76.15l-4.71-4.71,30-30H0v-6.9H81.68L51.69,4.7,56.4,0Z" />
    </g>
  </svg>
)

export default Next
